const IMAGE_EXTENSION_BY_MIME_TYPE: Record<string, string> = {
  'image/gif': 'gif',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/svg+xml': 'svg',
  'image/webp': 'webp'
}

function triggerDownload(href: string, name: string) {
  const anchor = document.createElement('a')
  anchor.href = href
  anchor.download = name
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

function getDownloadName(baseName: string, mimeType?: string) {
  if (/\.[a-z0-9]+$/i.test(baseName)) return baseName
  const extension = mimeType ? IMAGE_EXTENSION_BY_MIME_TYPE[mimeType] : undefined
  return extension ? `${baseName}.${extension}` : `${baseName}.png`
}

export const downloadFromUrl = async (url: string, name = 'image') => {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error('Failed image download request')
    }

    const blob = await response.blob()
    const blobUrl = URL.createObjectURL(blob)
    triggerDownload(blobUrl, getDownloadName(name, blob.type))
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
  } catch {
    triggerDownload(url, getDownloadName(name))
  }
}
